import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/swiper-bundle.min.css'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import filterText from './utils/filters'
import countTo from 'vue-count-to'
import rem from './utils/rem'
// import 'animate.css'
Vue.config.productionTip = false
Vue.use(VueAwesomeSwiper).use(ElementUI)
Vue.component('countTo',countTo)
Vue.config.productionTip = false
Vue.prototype.baseImageUrl = 'http://192.168.0.120/'
Vue.prototype.filterText = filterText
Vue.prototype.rem = rem
new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
